<script>
import { mapActions } from 'vuex';

export default {
  name: 'ProductCard',

  props: {
    product: { type: Object, required: true }
  },

  methods: {
    ...mapActions(['addToCart']),

    productClick() {
      VueEventHub.$emit('product-click', this.product);
    }
  }
};
</script>
